import { PrimaryAccountCategoriesService } from '@/modules/global-settings/general-ledger/services/primary-account-categories.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the primary account categories service
const primaryAccountCategoriesService = new PrimaryAccountCategoriesService();

// Primary account categories module state
export const state = {
  primaryAccountCategories: [],
  primaryAccountCategory: {}
};

// Primary account categories module mutations
export const mutations = {
  ...make.mutations(state),

  SET_PRIMARY_ACCOUNT_CATEGORIES: (state, payload) => {
    state.primaryAccountCategories = payload;
  },

  ADD_PRIMARY_ACCOUNT_CATEGORY: (state, payload) => {
    state.primaryAccountCategories.push(payload);
  },

  UPDATE_PRIMARY_ACCOUNT_CATEGORY: (state, { id, payload }) => {
    const index = state.primaryAccountCategories.findIndex((el) => el.id == id);
    state.primaryAccountCategories.splice(index, 1, payload);
  },

  UPDATE_DEFAULT_ACCOUNT_CATEGORIES: (state, payload) => {
    state.primaryAccountCategories.forEach(category => {
      if (category.useDefaultNumbers) {
        // Find the matching default category
        const defaultCategory = payload.find(def => def.name === category.name);
        if (defaultCategory) {
          // Set the accountNumber on the category
          category.accountNumber = defaultCategory.accountNumber;
        }
      }
    });
  },
};

// Primary account categories module actions
export const actions = {
  /**
   * Initialize primary account categories
   * @param {*} Object - Vuex context
   * @returns Array - Primary account categories
   */
  initializePrimaryAccountCategories: async ({ commit }) => {
    try {
      const { data } = await primaryAccountCategoriesService.initialize();
      commit('SET_PRIMARY_ACCOUNT_CATEGORIES', data);
      return data;
    } catch (error) {
      Logger.error('initializing primary account categories');
      throw error;
    }
  },

  /**
   * Fetch all primary account categories
   * @param {*} Object - Vuex context
   * @returns Array - Primary account categories
   */
  fetchPrimaryAccountCategories: async ({ commit }) => {
    try {
      const { data } = await primaryAccountCategoriesService.findAll();
      commit('SET_PRIMARY_ACCOUNT_CATEGORIES', data);
      return data;
    } catch (error) {
      Logger.error('fetching primary account categories');
      throw error;
    }
  },

  fetchDefaultPrimaryAccountCategories: async ({ commit }) => {
    try {
      const { data } = await primaryAccountCategoriesService.findDefault();
      commit('UPDATE_DEFAULT_ACCOUNT_CATEGORIES', data);
      return data;
    } catch (error) {
      Logger.error('fetching default primary account categories');
      throw error;
    }
  },

  /**
   * Update a primary account category with the given id and data
   * @param {*} Object - Vuex context
   * @param {*} Object - Primary account category ID & Primary account category data
   */
  updatePrimaryAccountCategory: async ({ commit }, { id, payload }) => {
    try {
      await primaryAccountCategoriesService.update(id, payload);
      commit('UPDATE_PRIMARY_ACCOUNT_CATEGORY', { id, payload });
    } catch (error) {
      Logger.error('updating primary account category');
      throw error;
    }
  },
};

// Primary account categories module getters
export const getters = make.getters(state);
